import { AppMode } from './AppMode';
import { StaticSettings } from './StaticSettings';
import { Type } from './Type';

export class RouteConstants {
    public static JobVacancy = '/stellenangebote';
    public static Candidate = '/kandidaten';

    public static routeForType(type: Type): string {
        if (StaticSettings.mode === AppMode.Both) {
            if (type === Type.Candidate) {
                return this.Candidate;
            } else {
                return this.JobVacancy;
            }
        } else {
            return '';
        }
    }
}

